import React, { FC, useMemo } from 'react';
import { NextPageContext } from 'next';
import Connection from '../../connection/Connection';
import ReactHtmlParser from 'react-html-parser';
import {
  CandidateLayout,
  DEFAULT_OG_IMAGES,
  SEO_COMMON,
} from '../../layout/candidate/CandidateLayout';
import styles from './sp.module.less';
import { ErrorPage } from '../error/ErrorPage';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';
import { useUserInfo } from '../../connection/Application';

type Props = {
  name: string;
  template: any;
};
const StaticWebPage: FC<Props> = ({ template }) => {
  const user = useUserInfo();
  const aditionalTags = useMemo(() => {
    if (template?.metaKeywords) {
      return [{ name: 'keywords', content: template.metaKeywords }];
    }
    return undefined;
  }, [template?.metaKeywords]);
  return (
    <CandidateLayout
      title={
        template?.title ? (
          <NextSeo
            canonical={template?.canonical}
            title={template?.title}
            description={
              template?.metaDescription ??
              'Careers360 is the most popular job portal for jobs in Sri Lanka, and to find out the best top job vacancies in Sri Lanka to your career next growth step'
            }
            additionalMetaTags={aditionalTags}
            openGraph={{
              title:
                template?.metaTitle ??
                `Jobs in Sri Lanka | Job Vacancies in ${Utils.moment().format(
                  'YYYY',
                )} | Careers360`,
              description:
                template?.metaDescription ??
                'Careers360 is the most popular job portal for jobs in Sri Lanka, and to find out the best top job vacancies in Sri Lanka to your career next growth step',
              images: DEFAULT_OG_IMAGES,
            }}
            {...SEO_COMMON}
          />
        ) : (
          '404 Not Found'
        )
      }>
      {template && (
        <div className={Utils.mergeClasses({ [styles.main]: true, [styles.user]: !!user })}>
          {ReactHtmlParser(template?.template?.html) as any}
        </div>
      )}
      {!template && <ErrorPage code={'404'} />}
    </CandidateLayout>
  );
};
export default StaticWebPage;

export const getStaticPagesProps = async (context: NextPageContext) => {
  const connection = Connection.nextConnection(context);
  try {
    const response = await connection.get(`masterdata/Static Page${(context as any).resolvedUrl}`);
    return {
      props: {
        template: response?.data ?? 'template undefined',
      },
    };
  } catch (e) {
    if ((context as any).resolvedUrl === '/coming-soon') {
      return {
        props: { template: null },
      };
    }
    return {
      redirect: {
        destination: '/coming-soon',
        permanent: false,
      },
    };
  }
};

export const getServerSideProps = async (context: NextPageContext) => {
  const connection = Connection.nextConnectionNoAuth();
  try {
    const response = await connection.get(`masterdata/Static Page/${context.query.name}`);
    return {
      props: {
        name: context.query?.name,
        template: response?.data ?? 'template undefined',
      },
    };
  } catch (e) {
    return {
      props: { template: null },
    };
  }
};
